import { getComsMobx,getAntd } from '../util/convert';

import { observable, action } from 'mobx';
import { fieldLinkageCfg , formulaCfg ,saveDetailExpSet,getDetailExpSet,exportFieldSet} from '../apis/req';
import { WeaLocaleProvider } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;

export class FieldLinkageCfg {

    @observable isFieldTrigger = '';
    @observable exportFieldType = '';

	@observable tips13= '';
    @observable isFormula = '';
    @observable conditions = [];
    @observable fixedForm = null;
    @observable SettingDialogVisible = false;

    /**
     * 初始数据
     */
    @action riggerFieldLinkageCfg(para={}){
        para = Object.assign(para,{optype:'get'});
        fieldLinkageCfg(para).then((reVal)=>{
            if(reVal.success){
                this.isFieldTrigger = reVal.isFieldTrigger;
                this.tips13 = reVal.tips13;
            }
        });
    }

    /**
     * update exportFieldType
     */
    @action updateExportFieldType( param={}){
        this.exportFieldType = param.exportFieldType;
        param = Object.assign(param, {optype : 'save',});
        exportFieldSet(param).then(()=>{});
    }

    /**
     * init exportFieldType
     */
    @action getExportFieldType( param={}){
        param = Object.assign(param,{ optype : 'get'})
        exportFieldSet(param).then((data)=>{
            this.exportFieldType = data.exportFieldType;
        });
    }

    /**
     * update isFieldTrigger
     */
    @action updateIsFieldTrigger(para={}){
        this.isFieldTrigger = para.isFieldTrigger;
        para = Object.assign(para,{optype:'save'});
        fieldLinkageCfg(para).then((reVal)=>{

        });
    }

    /**
     * 初始数据
     */
    @action riggerFormulaCfg(para={}){
        para = Object.assign(para,{optype:'get'});
        formulaCfg(para).then((reVal)=>{
            if(reVal.success){
                this.isFormula = reVal.isFormula;
            }
        });
    }

    /**
     * update isFieldTrigger
     */
    @action updateIsFormula(para={}){
        this.isFormula = para.isFormula;
        para = Object.assign(para,{optype:'save'});
        formulaCfg(para).then((reVal)=>{

        });
    }
    /**
     * 流程导入设置condition
     */
    @action getDetailExpSetFn=(para={})=>{
        const { WeaForm } = getComsMobx();
        this.fixedForm = new WeaForm();

        getDetailExpSet(para).then((res)=>{
            console.log(res);
            this.fixedForm.initFormFields(res.addFormConditions);
            this.conditions = res.addFormConditions            
        });
    }
    @action saveDetailExpSetFn=(para)=>{
        const {message} = getAntd();
        saveDetailExpSet(para).then((res)=>{
            console.log('接口返回数据');
            message.success(res.message||'保存成功')
            this.changeSettingDialogVisibleFn(false)
        });
    }
    @action changeSettingDialogVisibleFn=(flage)=>{
        this.SettingDialogVisible=flage
    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/importFieldLinkageCfg.js